import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './store';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import './assets/styles/app.css';

import PrivateRoute from './PrivateRoute';

import Auth from './views/Auth';
import Views from './views';

const store = configureStore({});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/login" exact component={Auth} />
        <PrivateRoute path="/" component={Views} />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);
